export { PromptWithInputs } from './PromptWithInputs';
